import { render, staticRenderFns } from "./aiReportPreview.vue?vue&type=template&id=d080ad24&scoped=true&"
import script from "./aiReportPreview.vue?vue&type=script&lang=js&"
export * from "./aiReportPreview.vue?vue&type=script&lang=js&"
import style0 from "./aiReportPreview.vue?vue&type=style&index=0&id=d080ad24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080ad24",
  null
  
)

export default component.exports